import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import HomePageAvantgardeImpl from './home-page-avantgarde.js';

const UIPage = MojitoCore.Presentation.UIPage;

/**
 * @namespace HomePageAvantgarde
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * Avantgarde design style home page.
 *
 * @class HomePageAvantgarde
 * @extends Mojito.Core.Presentation.UIPage
 * @memberof Mojito.Applications.Sports.Pages.HomePageAvantgarde
 */

/**
 * HomePageAvantgarde prop types.
 *
 * @property {boolean} [showQuickStartGuide = false] - Flag to render the Quick Start Guide component on the home page.
 *
 * @memberof Mojito.Applications.Sports.Pages.HomePageAvantgarde
 */
const propTypes = {
    showQuickStartGuide: PropTypes.bool,
};

const defaultProps = {
    showQuickStartGuide: false,
};

export default UIPage('HomePageAvantgarde', HomePageAvantgardeImpl, propTypes, defaultProps);
